export default {
  //投票添加
  SKVoteAdd: '',
  //投票详情
  SKVoteDetail: '',
  //投票选项
  SKVoteOpts: '',
}



// WEBPACK FOOTER //
// ./src/store/give-course/vote/states.js